import { render, staticRenderFns } from "./ServerDatatable.vue?vue&type=template&id=8bdb335a&"
import script from "./ServerDatatable.vue?vue&type=script&lang=ts&"
export * from "./ServerDatatable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports